var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Box",
    _vm._g(
      _vm._b(
        { style: { color: _vm.color }, attrs: { display: "inline" } },
        "Box",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("FontAwesomeIcon", {
        attrs: {
          icon: ["far", _vm.name],
          "fixed-width": _vm.fixedWidth,
          size: _vm.size,
          spin: _vm.spin
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }